import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { InstaPost } from '../models';
import { BASE_URL } from '@teamfoster/sdk/ssr';

@Injectable({
  providedIn: 'root',
})
export class InstagramService {
  private http = inject(HttpClient);
  private BASE_URL = inject(BASE_URL, { optional: true })!;

  getInstaPosts() {
    return this.http.get<InstaPost[]>(`${this.BASE_URL}api/insta-live`);
  }
}
